import { getTaskTime } from './helpers/getTaskTime';
import { getTimeFromPercent } from 'utils/helpers';
import * as Styled from './styles';
import { SubtaskModeSubtask } from 'types';

interface ITaskTimeProps {
  subtasks: SubtaskModeSubtask[];
}

export const TaskTime = ({ subtasks }: ITaskTimeProps) => {
  const { plannedHours, actualHours, templateHours } = getTaskTime(subtasks);
  return (
    <Styled.TaskTimeWrapper>
      <Styled.TaskTimeItem>
        <Styled.TaskTimeTitle>Planned:</Styled.TaskTimeTitle>
        <Styled.TaskTimeValue>
          {getTimeFromPercent(plannedHours)}
        </Styled.TaskTimeValue>
      </Styled.TaskTimeItem>

      <Styled.TaskTimeItem>
        <Styled.TaskTimeTitle>Actual:</Styled.TaskTimeTitle>
        <Styled.TaskTimeValue>
          {getTimeFromPercent(actualHours)}
        </Styled.TaskTimeValue>
      </Styled.TaskTimeItem>

      <Styled.TaskTimeItem>
        <Styled.TaskTimeTitle>Template:</Styled.TaskTimeTitle>
        <Styled.TaskTimeValue>
          {getTimeFromPercent(templateHours)}
        </Styled.TaskTimeValue>
      </Styled.TaskTimeItem>
    </Styled.TaskTimeWrapper>
  );
};
